export const environment = {
  apiUrl: 'https://backend.opus-m.de/api',
  production: true,
  mappTilerApiKey: 'i71G3CIpb6eRhgmsUgcI',
  telemetryDeckAppId: '16CE5265-52FD-4F46-B12E-B2AC5911039E',
  version: '1.0.0',
};
